function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _objectSpread({
        viewBox: "47 20 34 34"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx("rect", {
                x: "47",
                y: "20",
                width: "34",
                height: "34",
                rx: "17",
                fill: "#194BFB"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M71.5 37a.567.567 0 0 1-.563.562h-8.774a2.097 2.097 0 0 1-2.018 1.53c-.96 0-1.77-.652-2.018-1.53h-1.065A.567.567 0 0 1 56.5 37c0-.308.255-.563.563-.563h1.064a2.103 2.103 0 0 1 2.018-1.53c.967 0 1.77.653 2.017 1.53h8.776c.307 0 .562.255.562.563ZM71.5 42.362a.562.562 0 0 1-.563.563h-1.064a2.095 2.095 0 0 1-4.035 0h-8.775a.562.562 0 1 1 0-1.125h8.775a2.103 2.103 0 0 1 2.017-1.53c.96 0 1.77.652 2.017 1.53h1.066c.307 0 .562.255.562.563ZM71.5 31.637a.567.567 0 0 1-.563.563h-1.064a2.103 2.103 0 0 1-2.018 1.53c-.96 0-1.77-.653-2.017-1.53h-8.775a.562.562 0 1 1 0-1.125h8.775a2.095 2.095 0 0 1 4.035 0h1.064c.308 0 .563.247.563.562Z",
                fill: "#fff"
            })
        ]
    }));
};
export default Icon;
